import React from "react";
import bodyHelperTypes from "../utils/BodyHelperTypes";

import Links from "../components/Links";

const _1915ProviderResourceDocuments = [
    {
        format: bodyHelperTypes.paragraphs,
        order: 10,
        content: [
            <><Links linkTypeID="846" /></>
        ]
    },
];

export default _1915ProviderResourceDocuments;